import { render, staticRenderFns } from "./MaterialStandardMappingTabs.vue?vue&type=template&id=36b33fa1&scoped=true&"
import script from "./MaterialStandardMappingTabs.vue?vue&type=script&lang=js&"
export * from "./MaterialStandardMappingTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b33fa1",
  null
  
)

export default component.exports